import { render, staticRenderFns } from "./ArtigosCustomThemeCard.vue?vue&type=template&id=b942c62c&scoped=true&"
import script from "./ArtigosCustomThemeCard.vue?vue&type=script&lang=js&"
export * from "./ArtigosCustomThemeCard.vue?vue&type=script&lang=js&"
import style0 from "./ArtigosCustomThemeCard.vue?vue&type=style&index=0&id=b942c62c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b942c62c",
  null
  
)

export default component.exports